import { render } from "./CardsTab.vue?vue&type=template&id=c178e6ba"
import script from "./CardsTab.vue?vue&type=script&lang=js"
export * from "./CardsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__